import {ApptReasonId} from "./apptReasons";

export const PriceSlugByReasonId = {
  [ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING]: "rapid-covid-naat",
  [ApptReasonId.NEXT_DAY_RT_PCR]: "covid-expediated-sendout",
};
